import { useEffect } from 'react';
import { useAccount } from '../hooks/use-account';
import { withRouter } from './withRouter';

const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

const AuthVerify = ({ router }: any) => {
  const { location } = router;
  const { storageToken, logout } = useAccount();
  const checkToken = storageToken();
  useEffect(() => {
    if (checkToken) {
      const decodedJwt = parseJwt(checkToken.access_token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        logout();
      }
    }
  }, [location, logout, checkToken]);

  return <div />;
};

export default withRouter(AuthVerify);
